export default {
    maxLimit: "De maximale limiet mag niet meer dan zes cijfers bedragen.",
    emptyDeforestationStatus: "De EUDR ontbossingsstatus is leeg.",
    psw: "Wachtwoord",
    sunday: "Zondag",
    monday: "Maandag",
    tuesday: "Dinsdag",
    wednesday: "Woensdag",
    thursday: "Donderdag",
    friday: "Vrijdag",
    saturday: "Zaterdag",
    topFive: "Top vijf",
    used: "Gebruikt",
    confPsw: "Bevestig wachtwoord",
    newPsw: "Nieuw wachtwoord",
    email: "E-mail",
    emailId: "E-mail ID",
    submit: "Verzenden",
    cancel: "Annuleren",
    dashboard: "Dashboard",
    mainDashboard: "Hoofddashboard",
    userDashboard: "Gebruikersdashboard",
    faqs: "Veelgestelde vragen",
    id: "ID",
    processor: "Verwerker",
    cuppingScore: "Cuppingscore",
    label: "Label",
    totalFarmerLand: "Totaal boerenland",
    expiry: "Vervaldatum",
    users: "Gebruikers",
    appUser: "App-gebruiker",
    app_users: "App-gebruikers",
    dimitraAdmin: "Dimitra Beheerder",
    offline_users: "Offline gebruikers",
    admin_users: "Beheerdersgebruikers",
    search: "Zoeken",
    searchByProducerName: "Zoek op producentnaam",
    searchBy: "Zoeken op {type}",
    firstName: "Voornaam",
    lastName: "Achternaam",
    mobile: "Mobiel",
    mobileNumber: "Mobiel nummer",
    department: "Afdeling",
    role: "Rol",
    status: "Toestand",
    permission: "Toestemming",
    activity_log: "Activiteitenlogboek",
    profile_auth: "Profielauthenticatie",
    countryCode: "Landcode",
    selectDept: "Selecteer afdeling",
    selectRole: "Selecteer rol",
    edit: "Bewerken",
    goBack: "Terug",
    update: "Bijwerken",
    delete: "Verwijderen",
    view: "Bekijken",
    VIEW: "Bekijken",
    deactivate: "Deactiveren",
    activate: "Activeren",
    serverError: "Er is iets misgegaan. Probeer het later opnieuw.",
    minute: "Minuut",
    perHour: "Per uur",
    day: "Dag",
    enterDescription: "Voer hier uw beschrijving in",
    enterHere: "Voer hier in",
    enterMobile: "Voer mobiel nummer in",
    phoneRequired: "Telefoonnummer is verplicht",
    phoneValid: "Voer een geldig telefoonnummer in",
    unableToUpdate: "Niet in staat om bij te werken",
    membershipPlans: "Lidmaatschapsplannen",
    byWeek: "Per week",
    byMonth: "Per maand",
    byYear: "Per jaar",
    custom: "Aangepast",
    name: "Naam",
    hideLogo: "Logo verbergen",
    hours: "Uren",
    days: "Dagen",
    minutes: "Minuten",
    regionState: "Regio/Provincie",
    provinceState: "Provincie/Provincie",
    cityTown: "Stad/Dorp",
  village: "Dorp",
    membershipValidity: "Lidmaatschapsgeldigheid",
    exportAsCSV: "Exporteren als CSV",
    filterBy: "Filteren op",
    autoCondition: "Automatische voorwaarden",
    comingSoon: "Binnenkort beschikbaar",
    userRole: "Gebruikersrol",
    additionalInformationRequired: "Aanvullende informatie vereist",
    back: "Terug",
    browse: "Bladeren",
    clearAll: "Alles wissen",
    filterByRegion: "Filter op regio",
    continue: "Doorgaan",
    resolveNow: "Nu oplossen",
    description: "Beschrijving",
    extendedValidity: "Verlengde geldigheid",
    selectWeek: "Selecteer week",
    confirm: "BEVESTIGEN",
    selectMonth: "Selecteer maand",
    selectDateRange: "Selecteer datumbereik",
    regionDistrict: "Regio/District",
    address: "Adres",
    familyTribe: "Stam/Familie",
    website: "Website",
    deactivated: "Gedeactiveerd",
    active: "Actief",
    inactive: "Inactief",
    scheduled: "Gepland",
    country: "Land",
    state: "Staat",
    farmer: "Boer",
    commodity: "Handelswaar",
    quantity: "Hoeveelheid",
    unit: "Eenheid",
    price: "Prijs",
    save: "Opslaan",
    remove: "Verwijderen",
    stateIsReq: "Staat is verplicht",
    cityIsReq: "Stad is verplicht",
    addressIsReq: "Adres is verplicht",
    membershipTypeReq: "Type lidmaatschap is verplicht",
    extendedReasonReq: "Reden voor verlenging is verplicht",
    numberOfDaysReq: "Aantal dagen is verplicht",
    extendedMembershipValidity: "Verlengde lidmaatschapsgeldigheid",
    set: "Instellen",
    adminRole: "Beheerdersrol",
    typeMsg: "Typ hier uw bericht",
    mile: "Mijl",
    note: "*Opmerking: alleen mp4-bestanden worden ondersteund voor video",
    profile: "Profiel",
    pleaseChooseAnImageFile: "Kies een afbeeldingsbestand",
    fileIsTooBigSelectUnder1MB:
      "Uw bestand is te groot! Kies een afbeelding kleiner dan 1MB",
    pleaseTryAgainAfterSometime: "Probeer het later opnieuw",
    somethingWentWrong: "Er ging iets mis.",
    passwordChangedSuccesFully: "Wachtwoord succesvol gewijzigd",
    passwordDoesNotMatch: "Wachtwoorden komen niet overeen",
    copyToCliped: "Gekopieerd naar klembord",
    profileUpdated: "Profielgegevens bijgewerkt.",
    emailAndMobileCantbeEmpty: "E-mail en mobiel kunnen niet beide leeg zijn.",
    changePassword: "Wachtwoord wijzigen",
    generateSecurePassword: "Genereer een veilig wachtwoord",
    restoreDefault: "Herstel Standaard",
    customization: "Aanpassing",
    recordsPerPage: "Records per Pagina",
    done: "Klaar",
    dashboardSettings: "Dashboardinstellingen",
    weightUnit: "Gewichtseenheid",
    notifications: "Meldingen",
    createNewOfflineFarmer: "Nieuwe offline boer aanmaken",
    Honey: "Honing",
    "Natural (Dry)": "Natuurlijk (Droog)",
    Wine: "Wijn",
    "Semi-Washed": "Half Gewassen",
    "Full-Washed": "Volledig Gewassen",
    offlineFarmerForByingStationOnly:
      "Offline Farmer voor het kopen van alleen een station (lokaal)",
    offlineFarmerForAllByingStations:
      "Offline boer voor alle inkoopstations (wereldwijd)",
    manageOfflineFarmers: "Offline boeren beheren",
    addnewOfflineFarmer: "Nieuwe offline boer toevoegen",
    manageFarmer: "Boer Beheren ",
    hideSplash: "Verberg Splash",
    qrcode: "QR Code",
    lessThanOneMonth: "Minder dan 1 maand",
    oneTo8Month: "1 - 8 Maanden",
    sixTo12Month: "6-12 Maanden",
    moreThanYear: "Meer dan 1 jaar",
    emailSentSuccessfully: "E-mail succesvol verzonden",
    step: "Stap",
    fileError: "Bestandsfout",
    ProvideFileFormat:
      "Belangrijke opmerking: Geef het volgende formaat op (PNG/JPEG)",
    signHere: "Teken hier",
    warning: "Waarschuwing",
    markAllAsRead: "Alles markeren als gelezen",
    viewNotifications: "Bekijk meldingen",
    youAreUpToDate: "Je bent up-to-date",
    sendNotifications: "Verstuur meldingen",
    createNotification: "Melding maken",
    viewAllNotifications: "Bekijk alle meldingen",
    createNotificationForGroup: "Melding maken voor de groep/meerdere gebruikers",
    createNotificationForDimitra: "Melding maken voor de Dimitra Admin",
    pleaseCheckTickMark:
      "Vink het vinkje aan om de gebruiker aan de lijst toe te voegen",
    clearAllFilters: "Wis alle filters",
    numOfDaysRemaining: "Aantal resterende dagen",
    requesterNameIsRequired: "Aanvrager Naam is verplicht",
    messageIsRequired: "Bericht is verplicht",
    emailIsInvalid: "E-mail is ongeldig",
    emailIsRequired: "E-mail is verplicht",
    read: "Lezen",
    unread: "Ongelezen",
    all: "Alles",
    filesSucessfullyUploaded: "Bestanden succesvol geüpload",
  
    loadingData: "Gegevens laden...",
    markAsRead: "Markeren als gelezen",
  
    of: "van",
    ok: "OK",
  
    orderBy: "Sorteren op",
    select: "Selecteren",
    type: "Type",
    uploadImageVideo: "Afbeeldingen/video's uploaden",
    user: "Gebruiker",
    userName: "Gebruikersnaam",
    usersSelected: "Geselecteerde gebruikers",
    topics: "Onderwerpen",
    date: "Datum",
    addNew: "Nieuw toevoegen",
    exportAsCsv: "Exporteren als CSV",
    noData: "Geen gegevens gevonden",
  
    tickets: {
      actions: {
        create: "Ticket aanmaken",
        delete: "Ticket verwijderen",
        edit: "Ticket bewerken",
      },
      areaOfRequest: "Gebied van aanvraag",
      assignee: "Toegewijde",
      deleteTicket: {
        confirmation: "Weet u zeker dat u ticket {0} wilt verwijderen?",
      },
      dueDate: "Vervaldatum",
      filters: {
        ticketFor: "Ticket voor",
      },
      form: {
        ticketType: {
          admin: "Ticket aanmaken voor Admin Dimitra",
          user: "Ticket aanmaken voor de app-gebruiker",
        },
      },
      markAsRead: "Markeren als gelezen",
      messages: {
        created: {
          success: "Ticket succesvol aangemaakt",
        },
        deleted: {
          success: "Ticket succesvol verwijderd",
        },
      },
      noData: "Geen tickets gevonden!",
      noDataHelpText: `U heeft geen toegewezen tickets. Klik op de knop "Ticket aanmaken" bovenaan het scherm om te beginnen.`,
      pickerInMenu: "Selector in het menu",
      priority: {
        high: "Hoog",
        label: "Prioriteit",
      },
      reply: "Antwoorden",
      requestedDateTime: "Datum en tijd aangevraagd",
      requestorDetails: "Gegevens van de aanvrager",
      requestorEmail: "E-mail van de aanvrager",
      subject: "Onderwerp",
      ticketsForItems: {
        all: "Alle",
        dimitraAdmin: "Admin Dimitra",
        multipleUsers: "Meerdere gebruikers",
        singleUser: "Enkele gebruiker",
      },
      title: "Tickets",
    },
    roleRequest: {
      roleRequest: "Rol aanvragen",
      userRole: "Gebruikersrol",
      approve: "Goedkeuren",
      reject: "Afwijzen",
      username: "Gebruikersnaam",
      email: "E-mail",
      phone: "Telefoon",
      roleAssigned: "Toegewezen rol",
      roleRequested: "Aangevraagde rol",
      requestedDate: "Aangevraagde datum",
      updateRoleRequest: "Rol aanvraag bijwerken",
      message: "Bericht",
      update: "Bijwerken",
    },
    faqSection: {
      createFaq: "MAAK FAQ",
      createTopic: "Onderwerp aanmaken",
      selectTopic: "Selecteer onderwerp",
      faqQuestion: "Meest gestelde vraag",
      faqAnswer: "Antwoord op veelgestelde vraag",
      uploadImgVid: "Afbeelding/video uploaden",
      disInFaq: "Weergeven in veelgestelde vragen sectie",
      editFaq: "Veelgestelde vragen bewerken",
      topicName: "Onderwerpnaam",
      parentTopic: "Hoofdonderwerp",
      editTopic: "Onderwerp bewerken",
      createSection: "Maak eerst een sectie aan",
      createTopicFirst: "Maak eerst een onderwerp aan",
      questionReq: "Veelgestelde vraag is verplicht",
      answerReq: "Antwoord op veelgestelde vraag is verplicht",
    },
    cropsReport: "Gewassenrapport",
    today: "Vandaag",
    week: "Week",
    month: "Maand",
    year: "Jaar",
    cropsStatistics: "Gewassenstatistieken",
    crops: "Gewassen",
    acres: "Hectares",
    totalPlantedArea: "Totale beplante oppervlakte",
    farmersChart: "Grafiek van boeren",
    farmsChart: "Boerderijen grafiek",
    cropsName: "Naam van gewassen",
    farmers: "Boeren",
    farms: "Boerderijen",
    planted: "Beplant",
    plantedArea: "Beplante oppervlakte",
    harvested: "Geoogst",
    yieldAcre: "Opbrengst per hectare",
    selectCrop: "Gewas selecteren",
    listByYield: "Lijst opbrengst",
    listByPlantedArea: "Lijst beplante oppervlakte",
    equipmentReport: "Apparatuurrapport",
    equipmentChart: "Grafiek van apparatuur",
    selectFarmer: "Boer selecteren",
    selectFarmers: "Boeren selecteren",
    equipmentName: "Naam van apparatuur",
    region: "Regio",
    counts: "Aantallen",
    large: "Groot",
    medium: "Gemiddeld",
    small: "Klein",
    listByFarmer: "Lijst op boer",
    rowsPerPage: "Rijen per pagina",
    farmersReport: "Boerenrapport",
    farmsReport: "Boerderijenrapport",
    farmersStatistics: "Boerenstatistieken",
    farmStatistics: "Landbouwstatistieken",
    averageFarmerLand: "Gemiddelde boerderijgrootte",
    largeFarmers: "Grote boeren",
    mediumFarmers: "Gemiddelde boeren",
    smallFarmers: "Kleine boeren",
    listByLand: "Lijst op terrein",
    listByFarm: "Lijst op boerderij",
    AvgLandAcre: "Gemiddeld land per hectare",
    listbyCrop: "Lijst op gewas",
    listbyZone: "Lijst op zone",
    farmName: "Naam van de boerderij",
    zones: "Zones",
    area: "Oppervlakte",
    goalsAchievedReport: "Doelen bereikt rapport",
    listByCrops: "Lijst op gewassen",
    goalsAchievedChart: "Grafiek van bereikte doelen",
    goalsAchieved: "Bereikte doelen",
    goalsFailed: "Mislukte doelen",
    successRate: "Succespercentage",
    achieved: "Bereikt",
    equipment: "Apparatuur",
    pests: "Plagen",
    regions: "Regio's",
    filterByCrops: "Filteren op gewassen",
    searchCrops: "Zoeken naar gewassen",
    batchCode: "Batchcode",
    batchRating: "Batchbeoordeling",
    MakeASelection: "Maak een keuze",
    typeTotalCoffeeQuantity: "Voer totale hoeveelheid koffie in",
    typeHumidity: "Voer luchtvochtigheid in",
    valueInPercent: "Waarde in procent",
    purchaseOrderRequired: "Inkooporder vereist",
    totalCoffeeCherryRequired: "Totale koffiekers vereist",
    processTypeRequired: "Procestype vereist",
    stationInfo: "Stationinformatie",
    purchaseOrders: "Inkooporders",
    processingBatch: "Batch verwerking",
    processedCoffeeOutRequired: "Verwerkte koffie vereist",
    lotNo: "Lotnummer",
    addNewS: "Nieuwe toevoegen",
    viewAll: "Alles bekijken",
    parchmentOut: "Pergament uit",
    processingDone: "Verwerking voltooid",
    farmerLotID: "Boer en lot-ID",
    weight: "Gewicht",
    plantationSettings: "Plantage-instellingen",
    PlantationsEachFarmerCanCreate: "Aantal plantages dat elke boer kan aanmaken",
    manageAdditionalPlantationRequests: "Beheer extra plantageverzoeken",
    autoApprove: "Automatisch goedkeuren",
    adminApprovalRequired: "Goedkeuring van beheerder vereist",
    close: "Sluiten",
    new_user: "Nieuwe gebruiker",
    KGAcre: "KG/Hectare",
    pending: "In behandeling",
  
    //dashboard report
    "Farmer Name": "Naam van de Boer",
    "Goals Achieved": "Behaalde Doelen",
    "Goals Failed": "Mislukte Doelen",
    "Success Rate": "Succespercentage",
  
    "Equipment Name": "Naam van de Apparatuur",
    Region: "Regio",
    Farmer: "Agriculteur",
    Counts: "Aantallen",
  
    "Pest Name": "Naam van de Plaag",
    "Total Area": "Totale Oppervlakte",
    Crop: "Gewas",
  
    "Crop Name": "Naam van het Gewas",
    Farmers: "Boeren",
    Farms: "Farms",
    Planted: "Geplant",
    "Planted Area": "Geplante Oppervlakte",
    Harvested: "Geoogst",
    "Yield/acre": "Opbrengst per Hectare",
    "Region Name": "Naam van de Regio",
    "Avg. Land/Acre": "Gemiddeld Land per Hectare",
    Crops: "Gewassen",
    "Yield/area": "Opbrengst/oppervlakte",
    "Avg. land/Acre": "Gemiddeld land per Hectare",
    "Farm Name": "Naam van de Boerderij",
    Zones: "Zones",
    Area: "Oppervlakte",
  
    "Goals Achieved Report": "Rapport van Behaalde Doelen",
    "Farms Report": "Boerderijen Rapport",
    "Pest Report": "Plagen Rapport",
    "Equipment Report": "Apparatuur Rapport",
    "Crops Report": "Gewassen Rapport",
    "Farmers Report": "Boeren Rapport",
    "Regional Report": "Regionaal Rapport",
    fermentationCode: "Gistingscode",
  
    months: "Maanden",
    open: "Open",
    closed: "Gesloten",
    moreInfoRequired: "Meer Informatie Vereist",
    publicDueDiligenceReportSettings: "Public Due Diligence Report Settings",
    showingAll: "Alles Tonen",
    fieldRequired: "Dit veld is verplicht.",
    valueMustBeGreaterThanZero: "Waarde moet groter zijn dan nul.",
    valueExceedsLimit:
      "De vervaltijd mag volgens de EUDR-regelgeving niet langer zijn dan 12 maanden.",
    valueMustBeInteger: "Waarde moet een geheel getal zijn.",
    viewDeforestationDetails: "Bekijk Details van Deforestation",
    listOfShipments: "Lijst van Verzendingen",
    viewShipment: "Bekijk Verzending",
    shipmentCratedSuccess: "De verzending is succesvol aangemaakt.",
    pleaseSelectAtLeastOneDueDeligenceReport:
      "Selecteer alstublieft ten minste één due diligence-rapport",
    confirmation: "Bevestiging",
  
    dutch: {
      farmTitleDocument: "Boekdocumenten van de boerderij",
      technicianName: "Naam van de technicus",
      regBy: "Geregistreerd door",
      regDate: "Registratiedatum",
      farmRegistrationId: "Registratie-ID van de boerderij",
      farmerRegistrationId: "Registratie-ID van de boer",
      farmId: "Boerderij-ID",
      farmerName: "Naam van de boer",
      farmOwnershipType: "Soort eigendom van de boerderij",
      farmGoals: "Doelen van de boerderij",
      farmCertifications: "Certificeringen van de boerderij",
      farmInfo: "Informatie over de boerderij",
      provinceState: "Provincie/Staat",
      streetNumber: "Straatnummer",
      addGeofenceForThisFarm: "Voeg geofence toe voor deze boerderij",
      pleaseClickToChooseLocation: "Klik alstublieft om een locatie te kiezen",
      address: "Adres",
      geographicLocation: "Geografische locatie",
      searchLocation: "Zoek locatie",
      pleaseChooseOneOfTheOption: "Kies alstublieft een van de opties",
      useGeoFencingFeature: "Gebruik geofence-functie",
      uploadShapeFile: "Upload shapefile",
      uploadGeofence: "Upload geofence",
      upload: "Uploaden",
      reports: "Rapporten",
      generateReport: "Genereer rapport",
      avocado: "Avocado",
      avocadoTrees: "Avocadobomen",
      addNewFarmLocation: "Voeg een nieuwe boerderijlocatie toe",
      farmLocationAddress: "Adres van de boerderijlocatie",
      useGeofenceTool: "Gebruik geofence-tool",
      geofenceIsRequiredForSatelliteReport:
        "Opmerking: Geofence is vereist voor satellietrapporten",
      enterHere: "Voer hier in",
      primaryLocation: "Hoofdlocatie",
      secondaryLocation: "Secundaire locatie",
      locationAndSize: "Locatie en grootte",
      farmReports: "Rapport(en)",
      addNewZone: "Voeg een nieuwe zone toe",
      noZoneMessage: "Er is nog geen zone geregistreerd.",
      noZoneRequest:
        "Klik alstublieft op Voeg nieuwe zone toe om een zone voor deze boerderij te creëren.",
      locationZone: "Locatiezone",
      editFarmLocation: "Bewerk boerderijlocatie",
      addZone: "Voeg zone toe",
      nameOfTheZone: "Naam van de zone",
      zoneDetails: "Zonedetails",
      perimeter: "Omtrek",
      areaUnit: "Oppervlakte-eenheid",
      area: "Oppervlakte",
      zoneName: "Naam van de zone",
      farmGeofence: "Geofence van de boerderij",
      circularGeofence: "Circulaire geofence",
      polygonGeofence: "Polygonaal geofence",
      actions: "Acties",
      editZone: "Bewerk zone",
      numberOfGroups: "Aantal groepen",
      numberOfTrees: "Aantal bomen",
      group: "Groep",
      groupName: "Naam van de groep",
      numberOfAnimals: "Aantal dieren",
      status: "Status",
      primaryGeofence: "Primaire geofence",
      walkAndMeasure: "Lopen en meten",
      clearGeofence: "Wis geofence",
      deleteSelectedVertex: "Verwijder geselecteerde hoekpunt",
      basicInformation: "Basisinformatie",
      geofenceCategoryName: "Naam van de geofence-categorie",
      geofenceName: "Naam van de geofence",
      farmRadius: "Boerderijstraal",
      locationDisabledMessage:
        "Uw locatie is uitgeschakeld. Zoek alstublieft uw locatie in de menu's aan de linkerkant.",
      yourDistanceIs: "Uw afstand is",
    },
  
    confirmDialog: {
      assessmentBuilder: {
        delete: {
          title: "Verwijder Beoordeling",
          message: "Weet je zeker dat je de Beoordeling wilt verwijderen?",
          confirmBtn: "Bevestigen?",
        },
      },
      dueDiligenceReport: {
        delete: {
          title: "Verwijder EUDR Due Diligence Rapport",
          message:
            "Weet je zeker dat je het EUDR Due Diligence Rapport wilt verwijderen?",
          confirmBtn: "Bevestigen",
        },
      },
      farm: {
        delete: {
          title: "Verwijder Boerderij",
          message: "Weet je zeker dat je de Boerderij wilt verwijderen?",
          confirmBtn: "Bevestigen",
        },
      },
      status: {
        delete: {
          title: "Verwijder Ontbossingsstatus",
          message: "Weet je zeker dat je de ontbossingsstatus wilt verwijderen?",
          confirmBtn: "Bevestigen",
        },
      },
    },
  
    timeAgo: {
      minute: "een minuut geleden",
      minutes: "{count} minuten geleden",
      hour: "een uur geleden",
      hours: "{count} uur geleden",
      day: "een dag geleden",
      days: "{count} dagen geleden",
      month: "een maand geleden",
      months: "{count} maanden geleden",
      year: "een jaar geleden",
      years: "{count} jaar geleden",
    },
    pleaseAgreeToDeclaration: "Ga akkoord met de verklaring om af te ronden.",
    importProductionPlaceTT:
      "Stelt gebruikers in staat om productielocatiegegevens te importeren met behulp van bestand uploaden of downloaden opties.",
    defaultCircularGeofence:
      "Boerderijen zonder geofence of zonder informatie over hun grootte krijgen een standaard cirkelvormige geofence van 4 hectare toegewezen. Als de gemiddelde boerderijgrootte kleiner is dan 4 hectare, wijzig dan de standaardgrootte door op de knop 'Bewerken' hieronder te klikken.",
    accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon:
      "Volgens EUDR hebben boerderijen met minder dan 4 hectare geen polygoon nodig.",
    uploadOneDeforestationAssessmentForAllFarms:
      "UPLOAD EEN ONTBOSSINGSBEOORDELING VOOR ALLE BOERDERIJEN",
    uploadAssessment: "Beoordeling Uploaden",
    noUploadToBlockchain: "Geen Upload naar Blockchain",
    noDataForBlockchain:
      "Aangezien er geen ontbossingsrapporten zijn gegenereerd voor de productieplaatsen, waren er geen gegevens om naar de blockchain te schrijven. Als dit onverwacht was, zorg er dan voor dat de rapporten voor de boerderijen correct zijn gegenereerd in de vorige stappen.",
    seeDetails: "Details bekijken",

    countries: "Landen",
    clickHere: "Klik hier",
    tutorials: {
      howtoCreateanAdminUser: "Hoe maak je een beheerder aan",
      howToCreateanActivationKey: "Hoe maak je een activatiesleutel aan",
      individualandBulkFarmCreation: "Individuele en bulk boerderij creatie",
      creatingaDueDiligenceStatement: "Due diligence-verklaring aanmaken",
      title: "Tutorials & Gidsen",
      noTutorials: "Geen tutorials",
      addTutorialPrompt: "Voeg eerst een tutorial of gids toe.",
      videoNotAvailable: "Video niet beschikbaar in uw voorkeurstaal.",
      watchVideo: "Bekijk video",
      viewTutorial: "Bekijk tutorial",
      // Kenyan tutorials
      creatingAndManagingUsers: "Gebruikers aanmaken en beheren",
      howToCreateActivationKeys: "Hoe activatiesleutels aanmaken",
      userRolesAndPermissions: "Gebruikersrollen en -machtigingen",
      creatingAFarm: "Een boerderij aanmaken",
      creatingADueDiligenceStatement: "Due diligence-verklaring aanmaken",
      sharingStatementWithOperator: "Verklaring delen met operator",
      riskMitigation: "Risicomitigatie",
      generalSettings: "Algemene instellingen",
      assessmentBuilder: "Beoordelingsbouwer",
      bulkUserUpload: "Bulk gebruikersupload",
      // Admin management
      manageTutorials: "Tutorials Beheren",
      createTutorial: "Tutorial Aanmaken",
      editTutorial: "Tutorial Bewerken",
      deleteTutorial: "Tutorial Verwijderen",
      deleteConfirmation: "Weet je zeker dat je de tutorial '{title}' wilt verwijderen?",
      createSuccess: "Tutorial succesvol aangemaakt",
      updateSuccess: "Tutorial succesvol bijgewerkt",
      deleteSuccess: "Tutorial succesvol verwijderd",
      createError: "Fout bij het aanmaken van tutorial",
      updateError: "Fout bij het bijwerken van tutorial",
      deleteError: "Fout bij het verwijderen van tutorial",
      saveError: "Fout bij het opslaan van tutorial",
      loadError: "Fout bij het laden van tutorials",
      createFirstTutorial: "Maak je eerste tutorial aan om te beginnen",
      // Form fields
      description: "Beschrijving",
      url: "URL",
      urlType: "Inhoudstype",
      displayOrder: "Weergavevolgorde",
      organization: "Organisatie",
      organizationHint: "Selecteer 'Globaal' voor tutorials beschikbaar voor alle organisaties, of kies een specifieke organisatie",
      userType: "Gebruikerstype",
      userTypeHint: "Selecteer welk type gebruikers deze tutorial kunnen zien",
      isActive: "Is Actief",
      status: "Status",
      actions: "Acties",
      // Status options
      active: "Actief",
      inactive: "Inactief",
      global: "Globaal",
      // User types
      appUsers: "App Gebruikers",
      adminUsers: "Admin Gebruikers",
      // Validation messages
      titleRequired: "Titel is verplicht",
      titleMinLength: "Titel moet minimaal 3 karakters bevatten",
      urlRequired: "URL is verplicht voor externe links",
      urlInvalid: "Voer een geldige URL in",
      urlTypeRequired: "Inhoudstype is verplicht",
      fileRequired: "Bestand is verplicht voor bestandsgebaseerde tutorials",
      urlOrFileRequired: "URL of bestand moet worden opgegeven",
      // Search functionality
      searchOrganizations: "Zoek organisaties...",
      noOrganizationsFound: "Geen organisaties gevonden",
      searchTutorials: "Zoek tutorials...",
      selectOrganization: "Selecteer organisatie...",
      excludeGlobalForOrg: "Uitklappen globale tutorials voor organisatie",
      exclusionUpdateSuccess: "Configuratie tutorial organisatie bijgewerkt",
      exclusionUpdateError: "Fout bij bijwerken configuratie tutorial organisatie",
      exclusionStatusLoadError: "Fout bij laden configuratie tutorial organisatie",
    },
    helpDesk: "Helpdesk",
    generateSecretKey: "Genereer Geheime Sleutel",
    secretKey: "Geheime Sleutel",
    secretKeyCopied: "Geheime sleutel gekopieerd naar klembord",
    copied: "Gekopieerd",
    copySecretKeyHint: "Klik op de kopieerknop om de geheime sleutel te kopiëren",
  };
  